<template>
  <div class="center-user">
    <div class="left-tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="startSearch"
      ></TabelSearch>
      <!-- <el-button type="primary" @click="bingdDahua">绑定第三方用户</el-button> -->
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      ></Table>
    </div>

    <!-- 新增 -->
    <el-dialog
      :title="'绑定第三方用户'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm3"
        ref="dataForm"
        @keyup.enter.native="dataFormSubmit()"
        label-width="200px"
      >
        <el-form-item label="账号" prop="name">
          <el-input v-model="ruleForm3.name" placeholder="请输入账号"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm3.password" placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item label="账号类型">
          <el-select v-model="ruleForm3.type" placeholder="请选择类型">
            <el-option label="大华流媒体" value="1"></el-option>
            <el-option label="大华监控" value="2"></el-option>
            <el-option label="运维管理" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title1"
      :visible.sync="dialogVisible1"
    >
      <el-table :data="tableData">
        <el-table-column prop="name" label="账号"> </el-table-column>
        <el-table-column prop="password" label="密码"> </el-table-column>
        <el-table-column prop="typeName" label="类型"> </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="deleteRow(scope.row)"
              >解绑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 日历详情 -->
    <PersonInfo v-if="showPersonInfo" :typeName="choosedTypeName" :areaName="choosedAreaName" :personId="personId" @closePerson="closePerson"/>
  </div>
</template>
<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { systemApi } from "../../../../api-path/system-api.js";
import publicApi from "../../../../api-path/public-api";
import { dahuaApi } from "@/api-path/district-api";
import PersonInfo from './personInfo'
export default {
  name: "allUsers",
  components: {
    Tree,
    TabelSearch,
    PersonInfo
  },
  data() {
    return {
      switchVal: false,
      isEdit: false,
      userIds: [],
      tableData: [],
      title1: "绑定第三方账号",
      title: "",
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "type",
            valueType: "select",
            placeholder: "选择用户类型",
            option: {
              label: "itemName",
              value: "itemValue",
            },
            //path: publicApi.queryByCodeValue + '/PERSON_USER_TYPE',取消普通用户
            data: [
              { itemName: "接警员", itemValue: "1" },
              { itemName: "出警员", itemValue: "2" },
              { itemName: "区域权限", itemValue: "3" },
            ],
          },
          {
            key: "search",
            placeholder: "输入姓名/手机号查询/id",
          },
        ],
      },
      searchParams: {
        areaId: "",
        isDown: false,
        type: "",
        search: "", //名称或者帐号或者溯源ID
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type:'add',
          title:'绑定第三方用户',
          fn:()=>{
            this.bingdDahua()
          }
        }
      ],
      dialogVisible: false,
      dialogVisible1: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          this.userIds = data;
        },
        rows: [
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "真实姓名",
            prop: "realName",
          },
          {
            label: "类型",
            prop: "userTypeName",
          },
          {
            label: "备注",
            prop: "remark",
            type: "popover",
            width: "150px",
          },
        ],
        rowButtons: {
          width:'300px',
            items: [
              {
                label: '查看',
                type: 'primary',
                show: "userType.includes('2')? true : false",
                fn: (data)=>{
                  this.checkInfo(data)
                },
              },
            ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      ruleForm3: {
        name: "",
        password: "",
        type: "",
      },
      // 日历
      showPersonInfo:false,
      personId:'',
      choosedTypeName:"",
      choosedAreaName:""
    };
  },
  methods: {
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.search = "";
      this.searchParams.type = "";
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.startSearch();
    },

    getUserId() {
      if (this.userIds.length == 0) {
        this.$message.error("请选择用户");
        return null;
      } else if (this.userIds.length > 1) {
        this.$message.error("暂不支持多用户操作");
        return null;
      } else if (this.userIds.length == 1) {
        return this.userIds[0].id;
      }
    },

    bingdDahua() {
      let userId = this.getUserId();
      if (userId != null) {
        this.$http
          .get(dahuaApi.queryListByUserId, { params: { userId: userId } })
          .then((res) => {
            if (res.status === 200 && res.result.length > 0) {
              this.dialogVisible1 = true;
              this.tableData = res.result;
            } else {
              this.dialogVisible = true;
            }
          });
      }
    },

    //添加
    dataFormSubmit() {
      let userId = this.getUserId();
      if (userId != null) {
        this.ruleForm3.userId = userId;
        this.$http.post(dahuaApi.saveDahua, this.ruleForm3).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: "success",
              message: "添加成功！",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    //解绑
    deleteRow(row) {
      this.$http.get(dahuaApi.delDahua, { params: { id: row.id } }).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: "操作成功！",
          });
          this.dialogVisible1 = false;
        }
      });
    },

    checkInfo(data) {
      this.showPersonInfo=true;
      this.personId=data.id;
      this.choosedTypeName=data.typeName;
      this.choosedAreaName=data.areaName;
    },
    closePerson(){
      this.showPersonInfo=false;
    },

    startSearch() {
      this.$http.get(systemApi.managePage, { params: this.searchParams }).then((res) => {
        this.tableLoading = false;
        if (res.status == 200) {
          res.result.pageList.forEach((item) => {
            item.isAuthName = item.isAuth ? "是" : "否";
            item.userTypeName = item.typeName;
          });
          this.tableTemplateData = res.result.pageList;
          this.pagination.total = res.result.total;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.center-user {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
</style>
